export enum QuickPicks {
  Today = 'Today',
  Yesterday = 'Yesterday',
  LastWeek = 'Lastweek',
  LastMonth = 'Lastmonth',
  Last7Days = 'Last7days',
  Last30Days = 'Last30days',
  Last18Months = 'Last18Months',
  PreviousPeriod = 'Previousperiod',
  PreviousYear = 'Previousyear',
  Custom = 'Custom',
}
